<template>
  <div class="add-integration">
    <b-row>
      <b-col cols="12" v-if="stores.length > 0">
        <label for="from_extra" v-translate>Select a Shop</label>
        <b-form-select v-model="storeSelected" @input="selectedItem" :options="stores.map(x => { return { text: x.reference, value: x } })" class="mb-3">
          <template slot="first">
            <option :value="defaultOriginAddress" v-translate>Select a Shop</option>
          </template>
        </b-form-select>
      </b-col>
      <b-col cols="12" v-else>
        <b-alert variant="info" show>
          <h5 v-translate>Your company doesn't have any Store defined yet</h5>
          <div v-if="isCompanyAdmin">
            <p class="mb-0" v-translate>Fill in the infomation of all your stores, branches and warehouses</p>
            <b-btn size="sm" :to="{name: 'stores'}" variant="info" v-translate="{storeIcon: storeIcon}" render-html="true">%{storeIcon} HERE!</b-btn>
          </div>
          <div v-else>
            <p v-translate>You don't have permissions to fill the Stores' info. Please ask your Company Administrator to do it.</p>
          </div>
        </b-alert>
      </b-col>
      <div class="form-group col-sm-8">
        <label for="from_extra" v-translate>Street and number</label>
        <div class="input-group" v-if="!originAddress.from_place_id">
          <address-autocomplete
            ref="addressAutocomplete"
            @selected="selectedItem"
            static-items
            :minCharacter="4"
            :required="true"
          />
        </div>
        <p v-if="originAddress.from_place_id">
          {{ originAddress.from_formatted_address }}
          <b-badge variant="danger" href="#" @click.prevent="originAddress.from_place_id = null">×</b-badge>
        </p>
      </div>
      <div class="form-group col-sm-4">
        <label for="floor" v-translate>Floor, door, etc.</label>
        <div class="input-group">
          <b-form-input id="floor" v-model="originAddress.from_extra" />
        </div>
      </div>
      <div class="form-group col-sm-12">
        <label for="contact-name" v-translate>Contact</label>
        <div class="input-group">
          <b-form-input id="contact-name" v-model="originAddress.from_contact" required />
        </div>
      </div>
      <div class="form-group col-sm-6">
        <label for="contact-email" v-translate>Contact Email</label>
        <div class="input-group">
          <b-form-input trim id="contact-email" type="email" v-model="originAddress.from_email" />
        </div>
      </div>
      <div class="form-group col-sm-6">
        <label for="from_phone">Contact Phone</label>
        <div class="input-group">
          <cleave ref="phoneInput" :placeholder="$gettext('Enter your mobile phone number')" :options="{ phone: true, phoneRegionCode: this.$cookies.get('country').toLowerCase() }" class="form-control" v-model="originAddress.from_phone" required></cleave>
        </div>
      </div>
      <div class="form-group col-sm-12">
        <label for="from_contact">
          <translate>Special instructions on origin</translate> <em class="text-info"><small><translate>(up to 255 characters)</translate></small></em>
        </label>
        <div class="input-group">
          <b-form-textarea id="from_meta" name="from_meta" v-model="originAddress.from_meta" :rows="3" :max-rows="6" @input="countdown('from_meta', 255)" :state="invalid.from_meta" />
        </div>
        <p class='text-right' v-bind:class="{'text-danger': invalid.from_meta === false }"><small>{{limits.from_meta}}</small></p>
        <small class="form-text text-muted"><span v-translate="{courierI18n: this.courierI18n}">Do you have any special instruction for our %{courierI18n} on pick up?</span><br />
        <translate>i.e.</translate> <em v-translate>The elevator is not working</em></small>
      </div>
      <div class="text-right form-group col-12 form-actions">
        <b-spinner v-if="startSale" class="custom-spinner" variant="primary" label="Spinning"></b-spinner>
        <b-button
          type="submit"
          variant="primary"
          size="lg"
          @click.prevent="emitSuccess"
          :disabled="startSale"
          v-translate
        >Continue</b-button>
        <b-button
          type="button"
          variant="outline-primary"
          size="lg"
          @click.prevent="emitCancel"
          :disabled="startSale"
          v-translate
        >Cancel</b-button>
      </div>
    </b-row>
  </div>
</template>
<script>
import AddressAutocomplete from '@/components/AddressAutocomplete'
import AddAddress from '@/components/AddAddress'
import AddressMixin from '@/mixins/address.mixin'
import Cleave from 'vue-cleave'
import { icon } from '@fortawesome/fontawesome-svg-core'
import { faStore } from '@fortawesome/free-solid-svg-icons'

export default {
  name: 'ModalConfirmationBody',
  components: {
    AddressAutocomplete,
    AddAddress,
    Cleave
  },
  data() {
    const profile = this.$store.getters.profile
    const defaultAddress = profile.profile_address
    const defaultOriginAddress = {
      id: 'x',
      place_id: defaultAddress ? defaultAddress.place_id : null,
      place: {
        formatted_address: defaultAddress ? defaultAddress.place.formatted_address : ''
      },
      address_extra: defaultAddress ? defaultAddress.address_extra : '',
      contact: profile.name,
      email: profile.email,
      phone: profile.phone
    }
    return {
      stores: profile.company.stores,
      storeSelected: defaultOriginAddress,
      defaultOriginAddress,
      shipment: {},
      originAddress: defaultOriginAddress,
      invalid: {},
      limits: {},
      theCheckedAddress: {},
      startSale: false,
      storeIcon: icon(faStore).html
    }
  },
  watch: {
    theCheckedAddress(val) {
      this.originAddress.from_id = val.id
      this.originAddress.from_place_id = val.place_id
      this.originAddress.from_formatted_address = val.formatted_address
    }
  },
  computed: {
    hasCompany() {
      return this.$store.getters.profile && this.$store.getters.profile.company_id !== null
    },
    isCompanyAdmin() {
      return this.hasCompany && this.$store.getters.profile.company && this.$store.getters.profile.roles.findIndex(x => x.name === 'company-admin') !== -1
    }
  },
  mixins: [AddressMixin],
  created() {
    this.selectedItem(this.defaultOriginAddress)
  },
  methods: {
    emitCancel() {
      this.$emit('cancel')
    },
    emitSuccess() {
      if (this.originAddress.from_place_id) {
        this.startSale = true
        this.$emit('success', { originAddress: this.originAddress })
      }
    },
    focusAddressInput() {
      this.$refs.addAddress.$refs.addressAutocomplete.$el.children[0].focus()
    },
    selectedItem(item) {
      if (!item.id) {
        this.checkPlace(item)
      } else {
        this.originAddress = {
          from_place_id: item.place_id,
          from_formatted_address: item.place.formatted_address,
          from_extra: item.address_extra,
          from_contact: item.contact,
          from_email: item.email,
          from_phone: item.phone,
          from_meta: ''
        }
      }
    },
    countdown(value, limit) {
      this.limits[value] = this.originAddress[value] ? limit - this.originAddress[value].length : null
      this.invalid[value] = this.originAddress[value] ? this.originAddress[value].length <= limit : null
    }
  }
}
</script>

<style lang="scss">
.text-body {
  font-size: 18px;
}
.custom-spinner {
  top: 8px;
  position: relative;
  right: 10px;
}
</style>
